import React from 'react'

function Feature() {
    return (
        <div className='shapeBG'>
            <div className="container">
                <div className="row justify-content-center align-items-center">
                    <div className="col-lg-4 col-sm-4 col-12">
                        <div className="rules text-center">
                            <img src="images/memberIcon.png" className="img-fluid" alt="member image" />
                            <p className="ruleTitle">Your Match is Waiting! 
                            </p>
                            <p>Discover profiles based on your unique preferences—community, location, and more.</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-sm-4 col-12">
                        <div className="rules text-center">
                            <img src="images/visitIocn.png" className="img-fluid" alt="visit image" />
                            <p className="ruleTitle">Quick and Reliable Verification</p>
                            <p>We verify your profile with a simple process. A verified badge shows others you're serious and trustworthy.</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-sm-4 col-12">
                        <div className="rules text-center">
                            <img src="images/privacyIcon.png" className="img-fluid" alt="privacy image" />
                            <p className="ruleTitle">Secure Your Connections</p>
                            <p>Connect with confidence! Our robust privacy features empower you to control visibility, ensuring only selected individuals can view your profile and photos.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Feature